import React, { useEffect, useState, useRef } from "react";
import CommunityAbout from "../Posts/layouts/CommunityAbout";
import CommunityTopBar from "../Posts/layouts/CommunityTopBar";
import UpcomingEvents from "../Profile/UpcomingEvents";
import EventTopBar from "./EventTopBar";



const UpcomingEvent = () => {
  const userData = JSON.parse(localStorage.getItem('userData'));
  

  return (

    <div >
       <EventTopBar /> 
      <div className="community-features main ml-0">
        <div className="contents ml-0">
       <UpcomingEvents type ="events" />
       </div>
        <CommunityAbout></CommunityAbout>
      </div>
      </div>

  );

};
export default UpcomingEvent;